import React from "react";

const ProductCartLoader = () => {
  return (
    <div className="">
      <div class=" shadow rounded-md p-1 max-w-sm w-full mx-auto bg-base-100">
        <div class="animate-pulse">
          <div class=" bg-gray-200 h-48 rounded-sm"></div>
          <div className="bg-gray-200  rounded-lg h-2 w-4/5 mt-4 ml-2"></div>
          <div className="bg-gray-200  rounded-lg h-4 w-2/5 mt-4 ml-2"></div>
          <div className="flex">
            <div className="bg-gray-200  rounded-full h-4 w-4 mt-4 ml-2"></div>
            <div className="bg-gray-200  rounded-full h-4 w-4 mt-4 ml-2"></div>
            <div className="bg-gray-200  rounded-full h-4 w-4 mt-4 ml-2"></div>
            <div className="bg-gray-200  rounded-full h-4 w-4 mt-4 ml-2"></div>
            <div className="bg-gray-200  rounded-full h-4 w-4 mt-4 ml-2"></div>
            <div className="bg-gray-200  rounded-full h-4 w-4 mt-4 ml-2"></div>
          </div>
          <div className="bg-gray-200  rounded-sm h-7 w-full mt-4"></div>
          <div className="bg-gray-200  rounded-sm h-7 w-full mt-4"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductCartLoader;
